import { api } from "../../../../redux/apis/api";

const ok = (res) => {
  if (res?.data?.code === 200 || res?.data?.status === true) return res.data.data;
  const err = new Error(res?.data?.message || "Something went wrong");
  err.response = res;
  throw err;
};

export const listFormats = (type) => api.get(`/settings/custom-invoice/list`, { params: type ? { type } : {} }).then(ok);

export const getFormat = (id) => api.get(`/settings/custom-invoice/view`, { params: { id } }).then(ok);

// { id?, type, name, html, template_json, paper, set_default } -> { id }
export const saveFormat = (payload) => api.post(`/settings/custom-invoice/save`, JSON.stringify(payload)).then(ok);

export const deleteFormat = (id) => api.post(`/settings/custom-invoice/delete`, JSON.stringify({ id })).then(ok);

// format: a saved format id, or 1 for the built-in print
export const setDefaultFormat = (type, format) => api.post(`/settings/custom-invoice/set-default`, JSON.stringify({ type, format })).then(ok);

export const getPrintPreference = (type) =>
  api.get(`/settings/print-preference/list`, { params: { type } }).then((res) => res?.data?.data || null);

// Every format of a type rendered by the backend with sample data:
// [{ code: <format id> | "1" (standard print), html }]
export const listRenderedFormats = (type) =>
  api.get(`order/GetAllFormats`, { params: { type } }).then((res) => (Array.isArray(res?.data?.data) ? res.data.data : []));

// Data the editor designs against: a random document of the type, loaded by the
// backend with the same function the print endpoints use (placeholders when none).
// -> { meta: { kind: "document" | "placeholder", id, number }, data }
export const getPreviewData = (type) => api.get(`/settings/custom-invoice/preview-data`, { params: { type } }).then(ok);
